import { DEMO } from "./createGL";

export function getTurnFrame(moveDistanceX: number, initialFrame: number) {
  const getTurnAngle = (): number => (moveDistanceX / DEMO.TURNTABLE.MOUSE_SENSIBILITY) % 360;

  const frameDistance = Math.round((DEMO.TURNTABLE.TOTAL_FRAMES / 360) * getTurnAngle());
  const newFrame = (initialFrame + frameDistance) % DEMO.TURNTABLE.TOTAL_FRAMES;
  const newFrameInRange = newFrame < 0 ? DEMO.TURNTABLE.TOTAL_FRAMES + newFrame : newFrame;
  return newFrameInRange;
}
